var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.99984H11.4C11.7314 7.99984 12 8.26847 12 8.59984V12.7332C12 13.0645 11.7314 13.3332 11.4 13.3332H4.6C4.26863 13.3332 4 13.0645 4 12.7332V8.59984C4 8.26847 4.26863 7.99984 4.6 7.99984H5.33333M10.6667 7.99984V5.33317C10.6667 4.44428 10.1333 2.6665 8 2.6665C5.86667 2.6665 5.33333 4.44428 5.33333 5.33317V7.99984M10.6667 7.99984H5.33333",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c97a18bf8aeca6924e1c8e69578b1062.svg";
export { ForwardRef as ReactComponent };